import React, { createContext, useContext, useEffect } from 'react';
import { notification } from 'antd';
import notificationSuccess from "../assets/images/success.png";

type ToastContextType = {
  showNotification: (title?: string, description?: string, imageUrl?: string) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const showNotification = (title?: string, description?: string, imageUrl?: string) => {
    notification.open({
      message: '', // Dynamic title
      description: (
        <div className="d-flex custom-notification-content align-items-center p-0">
          <img src={notificationSuccess} alt="Notification Icon" className="notification-icon" />
          <div className='ps-2'>
          {title && <span className='d-block fs-14' style={{fontWeight:700}}>{title}</span>}
          {description && <span className='mutedtext'>{description}</span>} {/* Dynamic description */} 
          </div>
        </div>
      ),
      duration: 5, // Auto-hide after 5 seconds
      placement: 'topRight',
    });
  };

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     const storedToast = sessionStorage.getItem('toastMessage');
  //     if (storedToast) {
  //       try {
  //         console.log(storedToast)
  //         const { title = '', description = '' } = JSON.parse(storedToast); // Parse JSON object
  //         showNotification(title, description);
  //         sessionStorage.removeItem('toastMessage'); // Clear after displaying
  //       } catch (error) {
  //         console.error("Invalid toastMessage format in sessionStorage");
  //       }
  //     }
  //   }, 500);

  //   return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const storedToast = sessionStorage.getItem("toastMessage");
  
      if (storedToast) {
        try {
          // Ensure the value is a valid JSON string
          const parsedToast = JSON.parse(storedToast);
  
          // Validate structure to avoid undefined values
          if (
            parsedToast &&
            typeof parsedToast === "object" &&
            "title" in parsedToast &&
            "description" in parsedToast
          ) {
            const { title = "", description = "" } = parsedToast;
            showNotification(title, description);
          } else {
            console.error("Invalid toastMessage structure:", parsedToast);
          }
  
          sessionStorage.removeItem("toastMessage"); // Clear after displaying
        } catch (error) {
          console.error("Error parsing toastMessage:", error);
          sessionStorage.removeItem("toastMessage"); // Remove invalid entry
        }
      }
    }, 500);
  
    return () => clearInterval(intervalId);
  }, []);

  return (
    <ToastContext.Provider value={{ showNotification }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
